import type { CellRect, GridPoint } from "./cellRect";

/** The rectangle a fill-handle drag covers: the source and the pointer's cell together, along both axes. */
export const getFillRect = ({
    source,
    pointer,
}: {
    source: CellRect;
    pointer: GridPoint;
}): CellRect => ({
    top: Math.min(source.top, pointer.rowIndex),
    bottom: Math.max(source.bottom, pointer.rowIndex),
    left: Math.min(source.left, pointer.columnIndex),
    right: Math.max(source.right, pointer.columnIndex),
});

/** `index` repeated over `start..start + size - 1`, counted from `start` in both directions. */
const wrapIndex = ({
    index,
    start,
    size,
}: {
    index: number;
    start: number;
    size: number;
}) => start + ((((index - start) % size) + size) % size);

/**
 * The source cell a filled cell repeats. As in Excel and Sheets, the source
 * tiles outward from itself, up and left as well as down and right, so each
 * source cell maps to itself.
 */
export const getFillSourcePoint = ({
    source,
    point,
}: {
    source: CellRect;
    point: GridPoint;
}): GridPoint => ({
    rowIndex: wrapIndex({
        index: point.rowIndex,
        start: source.top,
        size: source.bottom - source.top + 1,
    }),
    columnIndex: wrapIndex({
        index: point.columnIndex,
        start: source.left,
        size: source.right - source.left + 1,
    }),
});

export const isInsideRect = (rect: CellRect, point: GridPoint) =>
    point.rowIndex >= rect.top &&
    point.rowIndex <= rect.bottom &&
    point.columnIndex >= rect.left &&
    point.columnIndex <= rect.right;
